import React from 'react';
import { NCZIEntrySection } from '../../../../Interfaces/ncziTypes';
import EHROpenableEntry from './EHROpenableEntry';
// @ts-ignore
import styles from './EHROpenableEntrySection.module.scss';

interface Props {
	section: NCZIEntrySection | undefined;
	patientIdentifier: string;
	onCloseDetail?: (needReload: boolean) => void;
}

const EHROpenableEntrySection: React.FC<Props> = props => {
	const { section, patientIdentifier, onCloseDetail } = props;

	if (!section) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.groupName}>{section.name}</div>
			{/*<small style={{fontSize: '10px'}}>{section.archetypeId}</small>*/}
			{section.entries.map((entry, key) => (
				<EHROpenableEntry
					item={entry}
					key={key}
					patientIdentifier={patientIdentifier}
					onCloseDetail={onCloseDetail}
				/>
			))}
		</div>
	);
};

export default EHROpenableEntrySection;
